<template>
  <div>
    <PlayerProfileTopInformation
      v-if="playerinfo && playerinfo.MEMBER"
      :config="config"
      :season="season"
      :refno="refno"
      :playerinfo="playerinfo"
      :enhancedPlayerInfo="enhancedPlayerInfo"
      :enhancedPlayerOOM="enhancedPlayerOOM"
      :DEFIMAGESAMS3="DEFIMAGESAMS3"
      :show_name_pronounce="show_name_pronounce"
      :name_pronounce="name_pronounce"
    />

    <div class="playerList">
      <PlayerProfileStats
        v-if="playerinfo"
        :config="config"
        :season="season"
        :playerinfo="playerinfo"
        :enhancedPlayerInfo="enhancedPlayerInfo"
        :enhancedPlayerOOM="enhancedPlayerOOM"
        :isMobile="isMobile"
        :playerinfoBestMoney="playerinfoBestMoney"
        :playerinfoCareerMoney="playerinfoCareerMoney"
        :myBagEquipment="myBagEquipment"
        :ShowTab="ShowTab"
      />
    </div>
  </div>
</template>

<script>
import apiCall from "@/services/api.js";
import PlayerProfileStats from "@/components/playerProfileStats.vue";
import PlayerProfileTopInformation from "@/components/playerProfileTopInformation.vue";

export default {
  name: "playerprofile",

  components: {
    PlayerProfileStats,
    PlayerProfileTopInformation
  },

  props: ["refno", "season", "config"],

  data() {
    return {
      playerinfo: null,
      enhancedPlayerInfo: {},
      enhancedPlayerOOM: "",
      show_name_pronounce: false,
      name_pronounce: "",
      myBagEquipment: [],
      ShowTab: "",
      playerinfoBestMoney: 0,
      playerinfoCareerMoney: 0,
      DEFIMAGESAMS3: "",
      loading: true
    };
  },

  metaInfo() {
    const enhanced = this.enhancedPlayerInfo || {};
    const member =
      this.playerinfo && this.playerinfo.MEMBER
        ? this.playerinfo.MEMBER
        : {};

    return {
      title: enhanced.full_name || member.FULL_NAME || "Player Profile",
      meta: [
        { charset: "utf-8" },
        {
          name: "description",
          content: this.description || ""
        }
      ]
    };
  },

  methods: {
    isMobile() {
      return typeof screen !== "undefined" && screen.width <= 760;
    },

    async loadPlayerProfile() {
      this.loading = true;

      try {
        // First API call: basic player information
        const firstCall = await apiCall.playersInfo(this.refno);
        const data = firstCall && firstCall.data
          ? firstCall.data
          : {};

        this.playerinfo = data;

        // General settings
        this.DEFIMAGESAMS3 =
          (data.GENERAL && data.GENERAL.DEFIMAGESAMS3) || "";

        // Career prize money statistics
        const statistics =
          data.STATISTICS && Array.isArray(data.STATISTICS.STATISTIC)
            ? data.STATISTICS.STATISTIC
            : [];

        this.playerinfoBestMoney =
          statistics[0] && statistics[0].VALUE != null
            ? statistics[0].VALUE
            : 0;

        this.playerinfoCareerMoney =
          statistics[1] && statistics[1].VALUE != null
            ? statistics[1].VALUE
            : 0;

        // Player name pronunciation
        this.show_name_pronounce = false;
        this.name_pronounce = "";

        const pronunciations =
          data.MEMBER && data.MEMBER.PRONOUNCIATIONS
            ? data.MEMBER.PRONOUNCIATIONS.PRONOUNCIATION
            : null;

        let pronunciationItems = [];

        if (pronunciations) {
          pronunciationItems = Array.isArray(pronunciations)
            ? pronunciations
            : [pronunciations];
        }

        const pronunciation = pronunciationItems.find(
          item => item && item.PHOTO_IMAGE
        );

        if (pronunciation) {
          this.show_name_pronounce = true;

          this.name_pronounce =
            "https://tms-images.ams3.cdn.digitaloceanspaces.com/sst/members/" +
            this.refno +
            "/" +
            pronunciation.PHOTO_IMAGE;
        }

        // What's in the Bag
        this.myBagEquipment = [];
        this.ShowTab = "";

        const equipmentItems =
          data.MYBAG && data.MYBAG.EQUIPMENT_ITEM
            ? data.MYBAG.EQUIPMENT_ITEM
            : [];

        const equipmentArray = Array.isArray(equipmentItems)
          ? equipmentItems
          : [equipmentItems];

        this.myBagEquipment = equipmentArray.filter(
          item => item && typeof item === "object"
        );

        // Show the tab if at least one item is marked as being in the bag.
        this.ShowTab = this.myBagEquipment.some(
          item => String(item.IN_BAG || "").toUpperCase() === "Y"
        )
          ? "Y"
          : "";

        // Second API call: enhanced player information
        const secondCall = await apiCall.playersEnhance(
          this.refno,
          this.season
        );

        const enhancedData =
          secondCall && secondCall.data
            ? secondCall.data
            : {};

        this.enhancedPlayerInfo = enhancedData;

        const oomDetails =
          enhancedData.ooms &&
          Array.isArray(enhancedData.ooms.tourn_details)
            ? enhancedData.ooms.tourn_details
            : [];

        const oomPosition = oomDetails[1];

        this.enhancedPlayerOOM =
          oomPosition && oomPosition.pos != null
            ? oomPosition.pos
            : "";

      } catch (error) {
        console.error("Error loading player profile:", error);
      } finally {
        this.loading = false;
      }
    }
  },

  mounted() {
    this.loadPlayerProfile();
  },

  watch: {
    refno() {
      this.loadPlayerProfile();
    },

    season() {
      this.loadPlayerProfile();
    }
  }
};
</script>